import Group from 'vux/src/components/group/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Step from 'vux/src/components/step/step.vue'
import StepItem from 'vux/src/components/step/step-item.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'

import ChinaAddressV4Data from '../../../common/ChinaAddressV4Data.json'
import uploadoss from '@/components/uploadoss'

export default {
name: 'storeInfo',
directives: {
TransferDom
},
components: {
Group,
XAddress,
Checklist,
Popup,
uploadoss,
Step,
StepItem,
CheckIcon,
},
data () {
return {
activeIndex: 0,
bannerSrc: 'https://hlh-shopping-image.oss-cn-shenzhen.aliyuncs.com/system/2019/0824/A686yE6MAR.jpg',
bannerImgList: [
"https://hlh-shopping-image.oss-cn-shenzhen.aliyuncs.com/system/2019/0824/A686yE6MAR.jpg",
"https://hlh-shopping-image.oss-cn-shenzhen.aliyuncs.com/system/2019/0824/rFz78PAK68.jpg",
"https://hlh-shopping-image.oss-cn-shenzhen.aliyuncs.com/system/2019/0824/fiDJHEWWRH.jpg",
"https://hlh-shopping-image.oss-cn-shenzhen.aliyuncs.com/system/2019/0824/CNYmyF6YR8.jpg",
"https://hlh-shopping-image.oss-cn-shenzhen.aliyuncs.com/system/2019/0824/KRXTwZrfAy.jpg",
],
selectAddressData: ChinaAddressV4Data,
headSrc: 'https://hlh-shopping-image.oss-cn-shenzhen.aliyuncs.com/system/2019/0824/n7s4zFYRka.png',
detailInfoData: {
sex: '',
realName: '',
designShopName: '',
address: [],
province: '',
city: '',
designShopIntro: '',

designImage: '',  //店铺头像
designShopBackImage: '',  //封面大图
},
sexOptions: ['男','女','保密'],
sexOption: [],
showSexOptions: false,
banner: {
btnName: '选择文件',
ossdata: [],
fileArr: [],
},
head: {
btnName: '上传头像',
ossdata: [],
fileArr: [],
},
isShopkeeper: false,
isNoBannerEvent: true,
isNoHeadEvent: true,
step: 0,
agree: true,
shopStatus: true,
turnDown: false,
turnDownText: '',
endStep: '完成',
showSetp: false,
submitBtnName: '提交'
}
},
methods: {
getStoreInfo () {
this.$request.post('/shop/getUserShopByUserId',{

}).then(data => {
if(data.code == 0){
if(data.obj != null){
if(data.obj.doneStatus == '0'){  //审核中
this.shopStatus = false
this.turnDown = false
this.step = 1
this.showSetp = true
}else if(data.obj.doneStatus == '1' && data.obj.auditStatus == '0'){  //审核不通过(驳回)
this.detailInfoData.sex = data.obj.sex
this.detailInfoData.realName = data.obj.realName
this.detailInfoData.designShopName = data.obj.designShopName
this.detailInfoData.province = data.obj.province
this.detailInfoData.city = data.obj.city
this.detailInfoData.designShopIntro = data.obj.designShopIntro
this.detailInfoData.designImage = data.obj.designImage
this.detailInfoData.designShopBackImage = data.obj.designShopBackImage
this.detailInfoData.address = [data.obj.province,data.obj.city]
this.bannerSrc = data.obj.designShopBackImage
this.headSrc = data.obj.designImage
this.turnDown = true
this.turnDownText = data.obj.remark
this.step = 2
this.endStep = '驳回'
this.activeIndex = -1
this.bannerImgList.forEach((item, index) => {
if(item == data.obj.designShopBackImage){
this.activeIndex = index
}
})
this.showSetp = true
this.submitBtnName = '重新提交'
}else if(data.obj.doneStatus == '1' && data.obj.auditStatus == '1'){  //审核通过
this.getShopkeeper()
}
}else{
this.showSetp = true
}
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
getShopkeeper () {
this.$request.post('/shop/getUserShopAuditByUserId',{

}).then(data => {
if(data.code == 0){
if(data.obj.doneStatus == '0'){  //审核中
this.shopStatus = false
this.turnDown = false
this.step = 1
this.showSetp = true
}else if(data.obj.doneStatus == '1' && data.obj.auditStatus == '0'){  //审核不通过(驳回)
this.detailInfoData.sex = data.obj.sex
this.detailInfoData.realName = data.obj.realName
this.detailInfoData.designShopName = data.obj.designShopName
this.detailInfoData.province = data.obj.province
this.detailInfoData.city = data.obj.city
this.detailInfoData.designShopIntro = data.obj.designShopIntro
this.detailInfoData.designImage = data.obj.designImage
this.detailInfoData.designShopBackImage = data.obj.designShopBackImage
this.detailInfoData.address = [data.obj.province,data.obj.city]
this.bannerSrc = data.obj.designShopBackImage
this.headSrc = data.obj.designImage
this.turnDown = true
this.turnDownText = data.obj.remark
this.step = 2
this.endStep = '驳回'
this.activeIndex = -1
this.bannerImgList.forEach((item, index) => {
if(item == data.obj.designShopBackImage){
this.activeIndex = index
}
})
this.showSetp = true
this.submitBtnName = '重新提交'
}else if(data.obj.doneStatus == '1' && data.obj.auditStatus == '1'){  //审核通过
this.detailInfoData.sex = data.obj.sex
this.detailInfoData.realName = data.obj.realName
this.detailInfoData.designShopName = data.obj.designShopName
this.detailInfoData.province = data.obj.province
this.detailInfoData.city = data.obj.city
this.detailInfoData.designShopIntro = data.obj.designShopIntro
this.detailInfoData.designImage = data.obj.designImage
this.detailInfoData.designShopBackImage = data.obj.designShopBackImage
this.detailInfoData.address = [data.obj.province,data.obj.city]
this.bannerSrc = data.obj.designShopBackImage
this.headSrc = data.obj.designImage

this.turnDownText = data.obj.remark
this.step = 3

this.activeIndex = -1
this.bannerImgList.forEach((item, index) => {
if(item == data.obj.designShopBackImage){
this.activeIndex = index
}
})
this.showSetp = false
this.showBottomNav = true
this.isShopkeeper = true
this.submitBtnName = '修改'
}
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
selectBanner (item, index) {
this.activeIndex = index
this.bannerSrc = item
},
onShadowChange () {
this.detailInfoData.province = this.$refs.addressArea.nameValue.split(' ')[0]
this.detailInfoData.city = this.$refs.addressArea.nameValue.split(' ')[1]
},
changeSex (val, label) {
this.detailInfoData.sex = val[0]
this.showSexOptions = false
},
reFlag () {
this.isNoBannerEvent = true
this.isNoHeadEvent = true
},

showossdataBanner(data) {
this.ossdata = data;
console.log(this.ossdata);

},
showossurlBanner(fileArr) {
this.banner.fileArr = fileArr
console.log(fileArr)
this.bannerSrc = fileArr[0].imgUrl
},
noBannerEvent () {
this.isNoBannerEvent = false
this.isNoHeadEvent = true
},
noHeadEvent () {
this.isNoHeadEvent = false
this.isNoBannerEvent = true
},

showossdataHead(data) {
this.ossdata = data;
console.log(this.ossdata);

},
showossurlHead(fileArr) {
this.banner.fileArr = fileArr
console.log(fileArr)
this.headSrc = fileArr[0].imgUrl
},
submitShopInfo (url) {
this.$request.post(url,this.detailInfoData).then(data => {
if(data.code == 0){
this.$vux.toast.show({
type: 'success',
text: '已提交，请等待审核'
})
this.getStoreInfo()
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
goHomePage () {
this.$router.push({
path: '/'
})
},
save () {
this.detailInfoData.designShopBackImage = this.bannerSrc
this.detailInfoData.designImage = this.headSrc
if(!this.$trim(this.detailInfoData.realName)){
this.$vux.toast.show({
type: 'warn',
text: '请输入真实姓名'
})
return false;
}
if(!this.detailInfoData.sex){
this.$vux.toast.show({
type: 'warn',
text: '请选择性别'
})
return false;
}
if(!this.$trim(this.detailInfoData.designShopName)){
this.$vux.toast.show({
type: 'warn',
text: '请输入店铺名称'
})
return false;
}
if(!this.$trim(this.detailInfoData.city)){
this.$vux.toast.show({
type: 'warn',
text: '请选择所在地区'
})
return false;
}
if(!this.$trim(this.detailInfoData.designShopIntro)){
this.$vux.toast.show({
type: 'warn',
text: '请输入简介'
})
return false;
}
if(!this.agree){
this.$vux.toast.show({
type: 'warn',
text: '请认真阅读协议'
})
return false;
}
delete this.detailInfoData.address
console.log(JSON.parse(JSON.stringify(this.detailInfoData)))

if(this.isShopkeeper){  //店主（修改）
this.submitShopInfo('/shop/designOssUpdate')

}else{  //未成为店主（申请）
this.submitShopInfo('/shop/register')

}
}
},
computed: {

},
created () {
this.getStoreInfo()
},
mounted() {

},
}



// WEBPACK FOOTER //
// ./src/views/myStore/storeInfo/script.js